// extracted by mini-css-extract-plugin
export default {"flex":"popover_flex__lTlmp","okButton":"popover_okButton__cdmBa","popoverBody":"popover_popoverBody__GJYRl","title":"popover_title__oUYG5","description":"popover_description__DVR-E"};